import { Component, Input } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ICerere } from 'src/app/components/cereri/cereri.interface';

@Component({
    selector: 'app-subsemnat',
    templateUrl: './subsemnat.component.html',
    styleUrls: ['./subsemnat.component.scss'],
})
export class SubsemnatComponent {
    @Input() cerere!: ICerere;
    isPersoanaFizica = true;
    isPersoanaJuridica = true;
    selectedSubsemnatulStatus = 'info';
    selectedPJStatus = 'info';
    selectedPJFiles = 'info';
    selectedBeneficiaryInfoStatus = 'info';
    selectedBeneficiarIndex = 0;

    onSubsemnatulInfoChange(event: MatButtonToggleChange) {
        this.selectedSubsemnatulStatus = event.value;
    }

    onPJInfoChange(event: MatButtonToggleChange) {
        this.selectedPJStatus = event.value;
    }

    onPJInfoFilesChange(event: MatButtonToggleChange) {
        this.selectedPJFiles = event.value;
    }

    onBeneficiarInfoChange(event: MatButtonToggleChange) {
        this.selectedBeneficiaryInfoStatus = event.value;
    }

    formatDate(date: string): string {
        return new Date(date).toLocaleString('ro-RO');
    }
}
